module.exports = __webpack_public_path__ + "static/home-img-b0ffd50c1698e1605f1716a79b342efe.png";